// src/components/auth/SignIn.tsx
import React from 'react';
import SignInFirebase from './SignInFirebase';
// import SignInDirects from './SignInDirects';
import './auth.css';

// --- Main SignIn Component (Layout) ---
const SignIn: React.FC = () => {
    return (
        // Use the generalized auth page container
        <div className="auth-page-container">
            <div className="auth-form-card"> {/* This card will contain the SignInFirebase component */}
                <SignInFirebase />
            </div>
            {/* 
            // May 6: turn off the classic OAuth based sign-in

            <div className="sign-in-column sign-in-column-firebase">
                <SignInFirebase />
            </div>

            <div className="sign-in-column sign-in-column-direct">
                <SignInDirects />
            </div> */}
        </div>
    );
}

export default SignIn;
